"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _excluded = ["isOpen", "hideModal", "children", "fullScreen", "size", "className"];
var BasicModal = function BasicModal(_ref) {
  var isOpen = _ref.isOpen,
    hideModal = _ref.hideModal,
    children = _ref.children,
    fullScreen = _ref.fullScreen,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: size,
    open: isOpen,
    onClose: hideModal,
    fullScreen: fullScreen
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: className
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right text-gray-light px-4 mt-4 -mb-8"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "cursor-pointer",
    onClick: hideModal
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8"
  }, children)));
};
var _default = exports["default"] = BasicModal;
//# sourceMappingURL=index.js.map